module.exports = __webpack_public_path__ + "static/media/1.0db7023a.jpg";